import { DialogModule } from './shared/dialog-component/dialog.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialComponentsModule } from './shared/material-components.module';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ShellComponent, SignedoOutShellComponent } from './shell/shell/shell.component';
import { ShellNavlistComponent } from './shell/shell/shell-navlist/shell-navlist.component';
import { HeaderInterceptor } from './interceptors/header.interceptor';
import { WelcomeComponent } from './welcome/welcome.component';
import { ProgressSpinnerDialogComponent } from './progress-spinner-dialog/progress-spinner-dialog.component';
import { ClarityModule } from '@clr/angular';
import { ResetPasswordComponent } from './login/resetpassword.component';
import { MAT_DATE_LOCALE } from '@angular/material';
import { RegisterComponent } from './register/register.component';
import { NationalUserModule } from './national-user/national-user.module';
import { AngularFileUploaderModule } from "angular-file-uploader";
import { PricesComponent } from './static/prices';
import { TermsComponent } from './static/terms';
import { ContactComponent } from './static/contact';
import { BulkEmailComponent } from './bulk-email/bulk-email';
import { EventsModule } from './events/events.module';
//import { ShowHidePasswordModule } from 'ngx-show-hide-password';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignedoOutShellComponent,
    ShellComponent,
    ShellNavlistComponent,
    WelcomeComponent,
    ProgressSpinnerDialogComponent,
    ResetPasswordComponent,
    RegisterComponent,
    TermsComponent,
    ContactComponent,
    PricesComponent,
    BulkEmailComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    BrowserAnimationsModule,
    MaterialComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    HttpClientModule,
   // ShowHidePasswordModule,
    AngularFileUploaderModule,
    ClarityModule,
    DialogModule,
    NationalUserModule,
    EventsModule 
  ],
  entryComponents: [ProgressSpinnerDialogComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-ZA' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
